import React, {useEffect, useRef} from 'react';
import {useControllerProps} from '../Widget/ControllerContext';
import {ShippingDetails} from './ShippingDetails/ShippingDetails';
import {DeliveryMethodFastFlow} from './DeliveryMethodFastFlow/DeliveryMethodFastFlow';
import {Text} from 'wix-ui-tpa/cssVars';
import {useLocaleKeys} from '../../../locale-keys/LocaleKeys';
import {classes} from './FastFlow.st.css';
import {FastFlowAnalyticsEventParams} from '../../../domain/utils/analytics.utils';
import {Checkboxes} from '../Checkboxes/Checkboxes';
import {ErrorDialog} from '../ErrorDialog/ErrorDialog';
import {ViolationsAndPlaceOrderButton} from '../ViolationsAndPlaceOrderButton/ViolationsAndPlaceOrderButton';
import {FastFlowForm} from './FastFlowForm/FastFlowForm';
import {BottomMobileSummary, BottomMobileSummaryDataHooks} from '../Summary/BottomMobileSummary/BottomMobileSummary';
import {classes as commonClasses} from '../../../common/common.st.css';
import {MemberOnlyFastFlow} from './MemberOnlyFastFlow/MemberOnlyFastFlow';
import {SPECS} from '../../../common/constants';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SecureCheckout} from '../../../common/components/SecureCheckout/SecureCheckout';

export enum FastFlowDataHook {
  root = 'FastFlow.root',
  title = 'FastFlow.title',
  violations = 'FastFlow.violations',
  Loader = 'FastFlow.loader',
}

// eslint-disable-next-line sonarjs/cognitive-complexity
export const FastFlow = () => {
  const {
    checkoutStore: {placeOrderError, cart, cartSummary, modalError},
    navigationStore: {trackEvent},
    checkboxesStore: {shouldShowCheckboxesSection},
    checkoutSettingsStore: {doesFastFlowFormHaveFieldsToDisplay},
    stepsManagerStore: {shouldShowMemberLoginStep},
    isOneColumnView,
  } = useControllerProps();
  const localeKeys = useLocaleKeys();
  const {experiments} = useExperiments();
  const checkboxesRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    trackEvent(...FastFlowAnalyticsEventParams);
  }, [trackEvent]);

  const shouldShowFastFlowForm = doesFastFlowFormHaveFieldsToDisplay;

  return (
    <div data-hook={FastFlowDataHook.root}>
      <div className={commonClasses.oneColumnViewPadding}>
        {shouldShowMemberLoginStep ? (
          <MemberOnlyFastFlow />
        ) : (
          <>
            <Text tagName={'h2'} className={classes.title} data-hook={FastFlowDataHook.title}>
              {localeKeys.checkout.place_order_fast_flow.title()}
            </Text>
            {cartSummary ? (
              <>
                <ShippingDetails />
                <DeliveryMethodFastFlow />
                <div
                  className={
                    shouldShowFastFlowForm || shouldShowCheckboxesSection ? classes.section : classes.buttonOnlySection
                  }>
                  {shouldShowFastFlowForm && <FastFlowForm extendedFields={cart.extendedFields} />}
                  <Checkboxes checkboxesRef={checkboxesRef} />
                </div>
              </>
            ) : (
              <div data-hook={FastFlowDataHook.Loader}>Loading...</div>
            )}
          </>
        )}
      </div>

      {isOneColumnView ? <BottomMobileSummary dataHook={BottomMobileSummaryDataHooks.placeOrderFastFlow} /> : null}
      <ViolationsAndPlaceOrderButton checkboxesRef={checkboxesRef} />
      {isOneColumnView && <SecureCheckout />}
      {(experiments.enabled(SPECS.NewCheckoutErrorModels)
        ? cart.noItemsError || modalError
        : cart.noItemsError || placeOrderError) && <ErrorDialog />}
    </div>
  );
};
